<template>
  <t-default-layout ref="defaultLayout" active-nav-id="trigger">
    <div id="t-trigger-component" class="t-trigger">
      <div class="t-trigger-heading-line">
        <a-page-heading class="t-trigger-heading-item">トリガー通知</a-page-heading>
      </div>
      <m-section>
        <div class="t-trigger-tabgroup">
          <m-action-card title="" icon="">
            <m-data-table
              header-id="trigger-table-header"
              body-id="trigger-table-body"
              :data="tableData"
              :border="true"
            >
              <a-data-table-column prop="displayName" label="トリガー名" align="left">
                <template #default="scope">
                  <a-text
                    :id="`trigger-name-${scope.row.triggerName}`"
                    tag="a"
                    href="#"
                    @click.prevent="handleEdit(scope.row)"
                  >
                    {{ scope.row.displayName }}
                  </a-text>
                </template>
              </a-data-table-column>
              <a-data-table-column type="action" :width="160" label="ON/OFF" class="a-data-table-column--action">
                <template #default="scope">
                  <m-form-input :id="`t-triggerFlag__form-input-${scope.row.triggerName}`">
                    <a-switch
                      :id="`t-triggerFlag-${scope.row.triggerName}`"
                      v-model="scope.row.pushFlag"
                      :data-testid="`trigger-toggle-button-${scope.row.triggerName}`"
                      :disabled="!isSuperUser"
                      @change="handleUpdatePushFlag(scope.row)"
                    />
                  </m-form-input>
                </template>
              </a-data-table-column>
            </m-data-table>
          </m-action-card>
        </div>
      </m-section>
    </div>
    <teleport to="body">
      <o-modal
        id="t-trigger-confirm-modal"
        :visible="modalVisible"
        data-testid="trigger-update-confirm-modal"
        class="o-modal-trigger-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        @close="handleCloseModal"
      >
        <template #title>{{ modalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="triggerUpdate_confirmModal_body" v-html="modalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="triggerUpdateModalCancelBtn"
            data-testid="trigger-update-modal-cancel-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="cancelUpdate"
          />
          <a-button
            id="triggerUpdateModalConfirmBtn"
            data-testid="trigger-update-modal-confirm-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="confirmUpdate"
          />
        </template>
      </o-modal>
    </teleport>

    <!-- Info, Error Modal -->
    <teleport to="body">
      <o-modal
        id="appReviewSettings_resultModal"
        :visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="resultModalOKBtn"
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import TDefaultLayout from '@/components/templates/default-layout';
import APageHeading from '@/components/atoms/page-heading';
import { customRequest } from '@/common/customRequest.js';
import { cloneDeep } from 'lodash';
import { messageContent } from '@/common/messageContent.js';
import { useVuelidate } from '@vuelidate/core';
import { triggerValidation } from '@/validations/trigger.js';

export default {
  name: 't-trigger',
  components: {
    TDefaultLayout,
    APageHeading, // 他のコンポーネントもインポートされていると仮定
  },
  mixins: [customRequest, messageContent],
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    const triggerNameMapping = {
      promote_login: 'ログイン促進',
      supervisor_point: '管理者MAU向上',
      login_user_coupon: 'ログインユーザー（ALL）MAU向上',
    };
    const triggerOrder = ['promote_login', 'supervisor_point', 'login_user_coupon'];

    return {
      triggerNameMapping,
      triggerOrder,
      tableData: [],
      targetRowForUpdate: null,
      modalVisible: false,
      modalTitle: '',
      modalContent: '',
      execUserID: this.$store.state.user.userID,
      authInfo: this.$store.state.user.authInfo,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      // バリデーション用のデータオブジェクト
      triggerData: {
        // trigger.jsのルールと一致させる
      },
    };
  },
  computed: {
    isSuperUser() {
      return this.authInfo === 'manager';
    },
  },
  validations() {
    // triggerDataオブジェクトに対してバリデーションを適用
    return triggerValidation.update();
  },
  created() {
    this.getTriggerList();
  },
  methods: {
    getTriggerList: function () {
      const data = {
        execUserID: this.execUserID,
      };
      this.postRequest('/trigger-notifications/get-list', data).then(res => { 
        const receivedData = (res && res.data) ? cloneDeep(res.data) : {};
        this.tableData = this.triggerOrder.map(triggerName => {
          const triggerData = receivedData[triggerName];
          if (triggerData) {
            // データが存在する場合
            triggerData.displayName = this.triggerNameMapping[triggerName] || triggerName;
            return triggerData;
          } else {
            // データが存在しない場合、デフォルトのデータを生成
            return {
              triggerName: triggerName,
              displayName: this.triggerNameMapping[triggerName] || triggerName,
              pushFlag: false,
              title: '',
              text: '',
              scheduleBusinessDays: 1,
              scheduleTime: '',
              deliveryStartDate: '',
              deliveryEndDate: '',
            };
          }
        });
      }).catch(error => {
        console.error('Failed to get trigger list:', error);
        this.showErrorModal(messageContent.requireTry('トリガー通知一覧の取得'));
      });
    },
    async handleUpdatePushFlag(row) {
      // ONにする時だけバリデーションを実行
      if (row.pushFlag) {
        // バリデーション用のデータに現在の行のデータをセット
        this.triggerData = {
          title: row.title || '',
          text: row.text || '',
          scheduleBusinessDays: row.scheduleBusinessDays === '' ? '' : Number(row.scheduleBusinessDays),
          scheduleTime: row.scheduleTime || '',
          deliveryStartDate: row.deliveryStartDate || '',
          deliveryEndDate: row.deliveryEndDate || '',
        };

        // Vuelidateのバリデーションを実行
        const isFormCorrect = await this.v$.$validate();
        if (!isFormCorrect) {
          this.showErrorModal('設定値が正しくないため、ONにできません。');
          // スイッチをOFFに戻す
          row.pushFlag = false;
          // v$の状態をリセット
          this.v$.$reset();
          return;
        }
        // v$の状態をリセット
        this.v$.$reset();
      }

      this.targetRowForUpdate = row;
      this.modalVisible = true;
      this.modalTitle = '設定変更の確認';
      this.modalContent = `${row.displayName}の設定を変更してよろしいでしょうか。`;
    },
    handleEdit(row) {
      this.$router.push({
        path: '/trigger/edit',
        query: { triggerName: row.triggerName },
      });
    },
    handleCloseModal() {
      if (this.targetRowForUpdate) {
        this.targetRowForUpdate.pushFlag = !this.targetRowForUpdate.pushFlag;
        this.targetRowForUpdate = null;
      }
      this.modalVisible = false;
      this.resultModalVisible = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    cancelUpdate() {
      if (this.targetRowForUpdate) {
        // スイッチのv-modelの値を反転させて元の状態に戻す
        this.targetRowForUpdate.pushFlag = !this.targetRowForUpdate.pushFlag;
        this.targetRowForUpdate = null;
      }
      this.handleCloseModal();
    },
    async confirmUpdate() {
      const row = this.targetRowForUpdate;
      if (!row) return;

      const payload = cloneDeep(row);
      
      // displayNameはサーバー側のモデルにないので削除
      delete payload.displayName;

      this.modalVisible = false;
      this.targetRowForUpdate = null;

      await this.postRequest('/trigger-notifications/update', payload)
        .then(() => {
          this.showInfoModal(messageContent.saveSuccess('トリガー通知設定'));
        })
        .catch(error => {
          // サーバーからのエラーメッセージがあれば表示し、なければ汎用メッセージを表示
          const message = error.response?.data?.errors?.[0]?.msg || messageContent.requireTry('トリガー通知設定の更新');
          this.showErrorModal(message);
          // 失敗したのでスイッチの状態を元に戻す
          row.pushFlag = !row.pushFlag;
        });
    },
  },
};
</script>
